import React from "react";
import { useEffect } from "react";
import MainContainer from "../../common/MainContainer";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { userLogout } from "../../redux/actions/UserActions";

const EditMockCategory = (props) => {
  let history = useHistory();
  const { id } = props.match.params;
  const basurl = process.env.REACT_APP_URL;
  const userToken = props.user.userToken;

  const { register, handleSubmit, errors, reset, setValue } = useForm();
  const onSubmit = (data, e) => {
    axios
      .put(
        `${basurl}/mock/categories/edit/${id}`,
        {
          title: data.category,
        },
        {
          headers: {
            "auth-token": userToken,
          },
        }
      )
      .then((res) => {
        const result = res.data;
        if (result.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Category added successfully.",
            showConfirmButton: false,
            timer: 1500,
          });
          e.target.reset();
          props.history.push("/mockcategories");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: result.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        // console.log("result >> ", result);
      })
      .catch((err) => {
        if (err.response.data === "Invalid token") {
          props.logoutUser();
          localStorage.removeItem("lmsUserInfo");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Your token has been expired!, Please login again",
            showConfirmButton: false,
            timer: 1500,
          });
          props.history.push("/");
        }
      });
  };

  // get mock details
  const getQuizDetails = () => {
    axios
      .get(`${basurl}/mock/categories/view/${id}`)
      .then((res) => {
        const result = res.data;
        if (result.success) {
          setValue("category", result.data.title);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getQuizDetails();
  }, [id]);
  return (
    <MainContainer>
      <div className="card">
        <div className={"card-header"}>
          <div className="row">
            <div className="col-sm-6">
              <h4>Add Mock Category</h4>
            </div>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
              <label>Category Name</label>
              <input
                type="text"
                className="form-control"
                placeholder={"Category Name"}
                name="category"
                ref={register({ required: true })}
              />
              {errors.category && (
                <span className="isError">Category is required.</span>
              )}
            </div>
            <div className={"d-flex"}>
              <button
                type="submit"
                className="btn btn-success"
                style={{ marginRight: 15 }}
              >
                Save Changes
              </button>
              <button
                type={"button"}
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Go Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainContainer>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: () => {
      dispatch(userLogout());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditMockCategory);
